import React from 'react'

import Image from '@/components/Image'
const InfosCard = ({card}) => {
  return (
    <div key={card._uid} className='flex-1 rounded-lg bg-violet-200 p-2'>
      <div className='flex flex-col gap-1'>
        <div className='justify-star flex items-center gap-2 rounded-md'>
          <div className='h-5 w-5'>
            <Image {...card.icon} ratio='1:1' />
          </div>
          <div className='body-s-medium text-purple-900'>{card.heading}</div>
        </div>
        <div className='flex flex-col'>
          <div className='body-xs-regular text-purple-400'>{card.description}</div>
        </div>
      </div>
    </div>
  )
}

export default InfosCard
